import MuiFormLabel, { FormLabelProps } from '@material-ui/core/FormLabel';
import React, { ElementType } from 'react';

type AllowedMuiFormLabelProps =
  | 'children'
  | 'color'
  | 'disabled'
  | 'error'
  | 'filled'
  | 'focused'
  | 'required';

interface IFormLabelProps<C = 'div'> extends Pick<FormLabelProps, AllowedMuiFormLabelProps> {
  component?: C;
}

const FormLabel = <C extends ElementType>(props: IFormLabelProps<C>) => <MuiFormLabel {...props} />;

export default FormLabel;
